import { Component, inject, ViewChild } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MessageService } from "primeng/api";
import { CarouselCardComponent } from "../../../components/carousel-card/carousel-card.component";
import { DeleteConfirmationComponent } from "../../../components/modal-templates/delete-confirmation/delete-confirmation.component";
import { TableViewModalComponent } from "../../../components/modal-templates/table-view-modal/table-view-modal.component";
import { SharedComponents } from "../../../components/shared.module";
import { testCaseMappingExpanded } from "../../../core/generic-templates/table-config-templates";
import { IBreadcrumb } from "../../../core/models/common";
import { ITestCaseEmitAction } from "../../../core/models/test-case";
import { TestPrioritizationActions } from "../../../core/ngrx/actions/test-prioritization.action";
import { selectMappingResponse } from "../../../core/ngrx/selectors/test-prioritization.selectors";
import { MessageEnum } from "../../../core/utils/message.enum";
import { BaseLayoutComponent } from "../../base-layout.component";
import { GenerateMappingComponent } from "../generate-mapping/generate-mapping.component";
import { ImpactedTestCaseAnlysisComponent } from "./impacted-test-case-analysis/impacted-test-case-analysis.component";
import { TestcaseMappingEditComponent } from "./testcase-mapping-edit/testcase-mapping-edit.component";

@Component({
  selector: "app-impactful-test-case",
  standalone: true,
  imports: [
    CarouselCardComponent,
    GenerateMappingComponent,
    TestcaseMappingEditComponent,
    ImpactedTestCaseAnlysisComponent,
    MatIconModule,
    ...SharedComponents,
  ],
  templateUrl: "./impactful-test-case.component.html",
  styleUrl: "./impactful-test-case.component.scss",
})
export class ImpactfulTestCaseComponent extends BaseLayoutComponent {
  private messageService = inject(MessageService);
  private modalService = inject(NgbModal);
  @ViewChild(GenerateMappingComponent) generateMappingComponent!: GenerateMappingComponent;

  items: any = [];
  viewMode: "all" | "view" | "create" | "edit" | "impacted-testcase-analysis" | "most-impacted-testcase-analysis" =
    "all";
  loading: boolean = false;
  mappingResponse$ = this.store.select(selectMappingResponse);
  createdMappingData = null;
  selectedType: any;
  selectedItems: any[] = [];

  carouselActions: any = [
    {
      name: "Edit",
      type: "edit",
      icon: "edit",
    },
    // {
    //   name: 'Detete',
    //   type: 'delete',
    //   icon: 'delete'
    // }
  ];

  fileName: any;

  ngOnInit() {
    this.mappingResponse$.subscribe((response) => {
      if (response) {
        this.createdMappingData = response;
      }
    });
    this.loadImpactfulTestCases();
    this.breadcrumbService.onNodeClick().subscribe((data: IBreadcrumb) => {
      if (data && data?.isRootNode) {
        this.viewMode = "all";
        this.selectedType = '';
      } else if (data?.clickable && data.key === "mappings") {
        this.viewMode = "create";
        this.selectedType = '';
      } else if(data.key === 'analysisType') {
        this.viewMode = 'edit';
        let brNode;
        if(data.meta?.isMostImpacted) {
          brNode = {
            name: 'Most Impacted Test Cases',
            key: 'analysisType',
            clickable: true,
            meta: {
              isMostImpacted: true
            }
          };
          this.selectedType = 'most-impacted';
        } else {
          brNode = {
            name: 'Impacted Test Cases',
            key: 'analysisType',
            clickable: true
          };
          this.selectedType = 'impacted';
        }
        this.breadcrumbService.addNode(brNode);
      }
    });
  }

  loadImpactfulTestCases() {
    this.loading = true;
    this.restService.getImpactfulTestCases(this.dataStore.data.id).subscribe({
      next: (response) => {
        this.items = response?.data;
        this.loading = false;
      },
      error: (err) => {
        console.error("Error fetching impactful test cases:", err);
        this.loading = false;
      }
    });
  }

  trackItem(index: number, item: any) {
    return item;
  }

  addNewMapping() {
    this.store.dispatch(
      TestPrioritizationActions.updateMappingResponse({ mappingResponse: {} })
    );
    this.viewMode = "create";
    this.breadcrumbService.addNode({
      name: "Mappings",
      key: "mappings",
      clickable: true,
    });
  }

  handleActions(event: ITestCaseEmitAction) {
    if (event?.type === "view_impacted") {
      this.viewMode = "impacted-testcase-analysis";
      this.breadcrumbService.addNode({
        name: 'Impacted Test Case',
        key: 'impacted-testcase'
      });
    }

    if (event?.type === "view_most_impacted") {
      this.fileName = event?.data?.file ? event?.data?.file : '';
      this.viewMode = "most-impacted-testcase-analysis";
      this.breadcrumbService.addNode({
        name: 'Most Impacted Test Case',
        key: 'impacted-testcase'
      });
    }

    if (event?.type == "edit") {
      this.store.dispatch(
        TestPrioritizationActions.updateMappingResponse({
          mappingResponse: event?.params ? event?.params : {},
        })
      );
    }
  }

  handleCardAction(event: any, item: any) {
    if (event.type === "mapping") {
      this.openGenericModal(item);
    } else if (event.type === "code_repo") {
      this.viewMode = "edit";
      this.store.dispatch(
        TestPrioritizationActions.updateMappingResponse({
          mappingResponse: item ? item : {},
        })
      );
    } else if (event.type === "select") {
      let ind = this.items.findIndex((ele: any) => ele.id === item.id);
      if (ind >= 0) {
        this.items[ind].selected = !this.items[ind].selected;

        if (this.items[ind].selected) {
          if (!this.selectedItems.find((sel: any) => sel.id === item.id)) {
            this.selectedItems.push(this.items[ind]);
          }
        } else {
          this.selectedItems = this.selectedItems.filter(
            (sel: any) => sel.id !== item.id
          );
        }
      }
    }
  }

  // handleAnalysisButtonAction(type: string) {
  //   this.selectedType = type;
  //   this.viewMode = 'edit';
  //   this.breadcrumbService.addNode({
  //     name: this.selectedType === 'most-impacted' ? 'Most Impacted Test Cases' : 'Impacted Test Cases',
  //     key: 'analysisType'
  //   });
  // }

  openGenericModal(item: any) {
    const modalRef = this.modalService.open(TableViewModalComponent, {
      centered: true,
      windowClass: "table-view-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.title = "Test Case to Source Code Mapping";
    modalRef.componentInstance.tableData = {
      columns: testCaseMappingExpanded,
      rows: []
    };
    modalRef.componentInstance.loader = {
      isLoading: true,
      text: 'Loading mapping data'
    };
    this.restService.getTestCases(item?.id).subscribe((response: any) => {
      if (response) {
        modalRef.componentInstance.tableData.rows = response?.data;
        modalRef.componentInstance.loader.isLoading = false;
      }
    }, error => {
      modalRef.componentInstance.loader.isLoading = false;
    });
  }

  openDeleteConfirmationModal() {
    let modalRef = this.modalService.open(DeleteConfirmationComponent, {
      windowClass:"delete-confirmation-window",
      centered: true,
      size: 'sm',
      backdrop: 'static'
    });
    modalRef.result
      .then((result) => {
        if (result) {
          this.removeMapping();
        }
      });
  }

  removeMapping() {
    const selectedIds = this.selectedItems.map((item) => item.id);
    this.restService.deleteMappingsBulk(selectedIds).subscribe({
      next: (response) => {
        this.items = this.items.filter(
          (item: any) => !selectedIds.includes(item.id)
        );
        this.toaster.pop({ type: 'success', text: MessageEnum.MAPPING_DELETION_SUCCESS });
      },
      error: (err) => {
        this.toaster.pop({ type: 'error', text: MessageEnum.MAPPING_DELETION_FAILURE });
      },
    });
    this.selectedItems = [];
  }

  isAnySelected() {
    return this.items.filter((ele: any) => ele.selected).length;
  }

  getActive(list: any[]) {
    return list.filter((ele: any) => ele.active);
  }


}
